import {
    Autocomplete,
    Button,
    Card,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    TextField
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, {
    useEffect,
    useState,
    useMemo
} from "react";
import { connect } from "react-redux";
import {
    getFormRecordsOption,
    labRecordCreate,
    labRecordCreateErrorClear
} from "store/app/lab-management/lab-records/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";
import debounce from "lodash.debounce";

const CreateLabRecords = (props) => {

    const { open, filter, paginationData, errorMessage, onClose, isPending } = props;

    const [labRecordData, setLabRecordData] = useState();
    const [errors, setErrors] = useState({});
    const [isAutoOpen, setIsAutoOpen] = useState();
    const [options, setOptions] = useState([]);
    //const loading = open && (options && options.length === 0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        props.labRecordCreateErrorClear();
        setLabRecordData();
        setErrors({});
    }, [open])

    const loadFormRecordsOption = (filter) => {
        setLoading(true);
        props.getFormRecordsOption(filter)
            .then((results) => {
                setOptions(results);
                setLoading(false);
            })
            .catch(() => {
                setOptions([]);
                setLoading(false);
            })
    }

    const validateOnchange = (e) => {
        const { name, value } = e.target;

        setLabRecordData({
            ...labRecordData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleFormRecordsSelect = (e, option) => {
        const { value, label } = option || {};
        setLabRecordData({
            ...labRecordData,
            farmRecordName: label,
            farmRecordId: value
        })
        setErrors({
            ...errors,
            farmRecordId: null,
        })
    }

    //---------------FILTER DROP DOWN------------------------------
    const debouncedFetchOptions = useMemo(() => debounce((query) => loadFormRecordsOption(query), 500), []);

    const handleFilter = (e) => {
        const { value } = e.target || {};
        debouncedFetchOptions(value);
    };

    const handleLabRecordCreate = (e) => {
        e.preventDefault();

        const { reportName } = labRecordData || {};
        const currentErrors = {};

        if (!reportName && !reportName?.trim()) {
            currentErrors.reportName = 'Report name is required';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.labRecordCreate(labRecordData, filter, paginationData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Create Lab Records
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                            <Grid item >
                                                <TextField
                                                    label={<div >Report Name <Required /></div>}
                                                    fullWidth
                                                    autoFocus
                                                    size="small"
                                                    name='reportName'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    error={errors?.reportName}
                                                    helperText={errors?.reportName}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={options}
                                                    open={isAutoOpen}
                                                    loading={loading}
                                                    onOpen={() => {
                                                        setIsAutoOpen(true);
                                                        loadFormRecordsOption();
                                                    }}
                                                    onClose={() => {
                                                        setIsAutoOpen(false);
                                                    }}
                                                    onChange={handleFormRecordsSelect}
                                                    value={labRecordData?.farmRecordName || null}
                                                    onInputChange={handleFilter}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Farm Record"
                                                        />
                                                    }
                                                    renderOption={(props, option) => (
                                                        <li {...props} key={option?.value}>
                                                            {option?.label}
                                                        </li>
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label={<div >Observation </div>}
                                                    fullWidth
                                                    multiline
                                                    minRows={4}
                                                    maxRows={10}
                                                    size="small"
                                                    name='observation'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleLabRecordCreate}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.labRecords.isLabRecordCreatePending,
    errorMessage: state.labRecords.labRecordCreateErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    labRecordCreate: (formData, filter, paginationData) => dispatch(labRecordCreate(formData, filter, paginationData)),
    labRecordCreateErrorClear: () => dispatch(labRecordCreateErrorClear()),
    getFormRecordsOption: (filter) => dispatch(getFormRecordsOption(filter)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateLabRecords);